<template>
    <div class="product-section">
        <div class="product-title">雾曼产品</div>
        <div class="product-container" ref="container" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel"
            @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
            <div class="product-wrapper" ref="wrapper" :style="transformStyle">
                <div v-for="(product, index) in displayProducts" :key="index" class="product-card"
                    @click="goToProduct(product)"
                    :class="{ 'active': (currentIndex % products.length) === (index % products.length) }">
                    <div class="product-image-container">
                        <img class="product-image" :src="product.image" alt="">
                    </div>
                    <div class="product-info">
                        <div class="product-tag">搭载伴生雾化技术®</div>
                        <div class="product-name">{{ product.name }}</div>
                        <div class="feature-list">
                            <div class="feature-item" v-for="(feature, fIndex) in product.features" :key="fIndex">
                                <div class="feature-icon">
                                    <img :src="feature.icon" alt="">
                                </div>
                                <div class="feature-text">{{ feature.text }}</div>
                            </div>
                        </div>
                        <div class="product-description">
                            <div class="description-item" v-for="(desc, dIndex) in product.descriptions" :key="dIndex">
                                {{ desc }}
                            </div>
                        </div>
                        <div class="learn-more">
                            <div class="learn-more-icon">
                                <img src="../assets/home22.png" alt="">
                            </div>
                            <div class="learn-more-text">马上了解</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="dots-container">
                <div v-for="n in products.length" :key="n - 1" class="dot"
                    :class="{ active: (currentIndex % products.length) === (n - 1) }" @click="jumpToSlide(n - 1)"></div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductSection',
    data() {
        return {
            products: [],
            currentIndex: 0,
            timer: null,
            isTransitioning: false,
            isHovered: false,
            cardWidth: 793,
            cardGap: 20,
            touchStartX: 0,
            touchEndX: 0,
            minSwipeDistance: 50
        }
    },
    computed: {
        displayProducts() {
            return [...this.products, ...this.products, ...this.products];
        },
        transformStyle() {
            const totalWidth = this.cardWidth + this.cardGap;
            const containerWidth = window.innerWidth;
            const offset = -(this.currentIndex * totalWidth) + (containerWidth - this.cardWidth) / 2;
            return {
                transform: `translateX(${offset}px)`,
                transition: this.isTransitioning ? 'transform 0.5s ease-in-out' : 'none'
            };
        }
    },
    async created() {
        try {
            const response = await this.$http.get('cms/content/front-list', {
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    catalogId: '636455896526917'
                }
            });

            if (response.data && response.data.rows) {
                this.products = response.data.rows.map(item => ({
                    contentId: item.contentId,
                    image: item.logoSrc,
                    name: item.title,
                    features: item.tags?.map((tag, index) => ({
                        icon: require(`../assets/home${19 + index}.png`),
                        text: tag
                    })) || [],
                    descriptions: item.summary ? item.summary.split('\n') : [],
                }));

                if (this.products.length > 0) {
                    this.currentIndex = this.products.length;
                    this.startCarousel();
                }
            }
        } catch (error) {
            console.error('获取产品数据失败:', error);
        }

        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        handleResize() {
            if (window.innerWidth <= 768) {
                this.cardWidth = window.innerWidth - 40; // 考虑padding
                this.cardGap = 10;
            } else if (window.innerWidth <= 1400) {
                this.cardWidth = 600;
                this.cardGap = 20;
            } else {
                this.cardWidth = 793;
                this.cardGap = 20;
            }
        },
        startCarousel() {
            this.stopCarousel();
            this.timer = setInterval(() => {
                if (!this.isHovered) {
                    this.nextSlide();
                }
            }, 4000);
        },
        stopCarousel() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        async nextSlide() {
            if (this.isTransitioning) return;

            this.isTransitioning = true;
            this.currentIndex++;

            await this.$nextTick();

            if (this.currentIndex >= this.products.length * 2) {
                setTimeout(() => {
                    this.isTransitioning = false;
                    this.currentIndex = this.products.length;
                }, 500);
            } else {
                setTimeout(() => {
                    this.isTransitioning = false;
                }, 500);
            }
        },
        async prevSlide() {
            if (this.isTransitioning) return;

            this.isTransitioning = true;
            this.currentIndex--;

            await this.$nextTick();

            if (this.currentIndex < this.products.length) {
                setTimeout(() => {
                    this.isTransitioning = false;
                    this.currentIndex = this.products.length * 2 - 1;
                }, 500);
            } else {
                setTimeout(() => {
                    this.isTransitioning = false;
                }, 500);
            }
        },
        jumpToSlide(index) {
            if (this.isTransitioning) return;

            this.isTransitioning = true;
            this.currentIndex = this.products.length + index;

            setTimeout(() => {
                this.isTransitioning = false;
            }, 500);
        },
        pauseCarousel() {
            this.isHovered = true;
        },
        resumeCarousel() {
            this.isHovered = false;
        },
        goToProduct(product) {
            this.$router.push({
                path: '/product',
                query: {
                    id: product.contentId
                }
            }).catch(err => {
                console.error('路由跳转失败:', err);
            });
        },
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.pauseCarousel();
        },
        handleTouchMove(event) {
            this.touchEndX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const swipeDistance = this.touchStartX - this.touchEndX;
            if (Math.abs(swipeDistance) > this.minSwipeDistance) {
                if (swipeDistance > 0) {
                    // 向左滑动，显示下一张
                    this.nextSlide();
                } else {
                    // 向右滑动，显示上一张
                    this.prevSlide();
                }
            }
            this.resumeCarousel();
        }
    },
    beforeDestroy() {
        this.stopCarousel();
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
.product-section {
    width: 100%;
    height: 739px;
    background-color: #F5F6F7;
    overflow: hidden;
}

.product-title {
    font-size: 40px;
    color: #000000;
    font-weight: bold;
    width: 100%;
    text-align: center;
    padding-top: 100px;
}

.product-container {
    position: relative;
    padding-top: 50px;
    overflow: hidden;
    width: 100%;
}

.product-wrapper {
    display: flex;
    gap: 20px;
    padding: 0 20px;
}

.product-card {
    width: 793px;
    height: 448px;
    background: #FFFFFF;
    border-radius: 16px;
    display: flex;
    flex-shrink: 0;
    opacity: 0.7;
    transform: scale(0.95);
    transition: all 0.5s ease-in-out;
}

.product-card.active {
    opacity: 1;
    transform: scale(1);
}

.product-image-container {
    padding-left: 14px;
    padding-top: 45px;
}

.product-image {
    width: 287px;
    height: 362px;
}

.product-info {
    padding-left: 13px;
    padding-top: 45px;
}

.product-tag {
    width: 159px;
    height: 28px;
    background: #F1FAEC;
    border-radius: 4px;
    font-size: 16px;
    color: #24A80A;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
}

.product-name {
    font-size: 28px;
    font-weight: bold;
    color: #000000;
    font-family: SourceHanSansSC, SourceHanSansSC;
    margin-top: 7px;
}

.feature-list {
    margin-top: 16px;
    display: flex;
}

.feature-item {
    display: flex;
    padding: 8px 12px;
    background: #FAFAFA;
    border-radius: 8px;
    border: 1px solid #E0E0E0;
    margin-right: 12px;
}

.feature-icon {
    width: 21px;
    height: 21px;
}

.feature-text {
    font-size: 16px;
    color: #000000;
    font-family: SourceHanSansSC, SourceHanSansSC;
    margin-left: 7px;
    line-height: 20px;
}

.product-description {
    margin-top: 18px;
}

.description-item {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 10px;
}

.learn-more {
    display: flex;
    margin-top: 55px;
    cursor: pointer;
}

.learn-more:hover {
    opacity: 0.8;
}

.learn-more-icon {
    width: 18px;
    height: 19px;
}

.learn-more-text {
    font-size: 15px;
    color: #B80708;
    line-height: 21px;
    text-align: left;
    margin-left: 8px;
}

.dots-container {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dot {
    background: #D8D8D8;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 15px;
    cursor: pointer;
}

.dot:last-child {
    margin-right: 0;
}

.dot.active {
    background: #9D9D9D;
}

@media screen and (max-width: 1400px) {
    .product-card {
        width: 600px;
    }

    .product-image {
        width: 220px;
        height: auto;
    }
}

@media screen and (max-width: 768px) {
    .product-section {
        height: auto;
        padding-bottom: 40px;
    }

    .product-title {
        font-size: 32px;
        padding-top: 40px;
    }

    .product-container {
        padding-top: 20px;
        touch-action: pan-y;
    }

    .product-wrapper {
        gap: 10px;
        padding: 0 0px;
    }

    .product-card {
        width: calc(100vw - 40px);
        height: auto;
        flex-direction: column;
        padding: 20px;
    }

    .product-image-container {
        padding: 0;
        display: flex;
        justify-content: center;
    }

    .product-image {
        width: 200px;
        height: auto;
    }

    .product-info {
        padding: 20px 0 0 0;
    }

    .product-name {
        font-size: 24px;
    }

    .feature-list {
        flex-wrap: wrap;
        gap: 10px;
    }

    .feature-item {
        margin-right: 0;
    }

    .product-description {
        margin-top: 15px;
    }

    .learn-more {
        margin-top: 20px;
    }
}
</style>
